/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TextGenerationDataset } from './TextGenerationDataset';
import {
  TextGenerationDatasetFromJSON,
  TextGenerationDatasetFromJSONTyped,
  TextGenerationDatasetToJSON,
} from './TextGenerationDataset';

/**
 *
 * @export
 * @interface PaginatedTextGenerationDatasetList
 */
export interface PaginatedTextGenerationDatasetList {
  /**
   *
   * @type {number}
   * @memberof PaginatedTextGenerationDatasetList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedTextGenerationDatasetList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedTextGenerationDatasetList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<TextGenerationDataset>}
   * @memberof PaginatedTextGenerationDatasetList
   */
  results: Array<TextGenerationDataset>;
}

/**
 * Check if a given object implements the PaginatedTextGenerationDatasetList interface.
 */
export function instanceOfPaginatedTextGenerationDatasetList(
  value: object,
): value is PaginatedTextGenerationDatasetList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedTextGenerationDatasetListFromJSON(json: any): PaginatedTextGenerationDatasetList {
  return PaginatedTextGenerationDatasetListFromJSONTyped(json, false);
}

export function PaginatedTextGenerationDatasetListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedTextGenerationDatasetList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(TextGenerationDatasetFromJSON),
  };
}

export function PaginatedTextGenerationDatasetListToJSON(value?: PaginatedTextGenerationDatasetList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(TextGenerationDatasetToJSON),
  };
}
